export function formatDisplayName(name) {
    return name
        .replace(/-(.)/g, function ($1) {
        return $1.toUpperCase();
    })
        .replace(/-/g, '')
        .replace(/^(.)/, function ($1) {
        return $1.toUpperCase();
    });
}
